import {Component, OnInit, Input} from '@angular/core';
import {CguService} from '../../services/cgu.service';
import {CguTypeEnum} from './cgu.model';

@Component({
    selector: 'jhi-cgu',
    templateUrl: 'cgu.component.html',
    styleUrls: ['cgu.component.scss']
})
export class CguComponent implements OnInit {

    cguText: string;

    @Input()
    public cguTypeEnum: CguTypeEnum;

    constructor(private cguService: CguService) {
    }

    ngOnInit(): void {
        this.cguService.getCgu(this.cguTypeEnum)
            .subscribe(cguText => this.cguText = cguText);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/conditions-generales/cgu.component.ts